import React, { useState } from 'react';
import { adminService } from '../services/api';
import './LoginModal.css';
import './AdminLoginPage.css';

/**
 * Acceso administrativo (staff) — ruta /admin-login
 */
const AdminLoginPage = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      localStorage.removeItem('javiland_token');
      const res = await adminService.adminLogin(formData.email.trim(), formData.password);
      const inner = res?.data;
      const token = inner?.token;
      const user = inner?.user;
      if (!res?.success || !token || !user) {
        setError(res?.message || 'No se pudo iniciar sesión');
        setIsSubmitting(false);
        return;
      }
      localStorage.setItem('javiland_token', token);
      localStorage.setItem('javiland_user', JSON.stringify({
        id: user.id,
        name: user.name,
        email: user.email,
        isSpecial: true
      }));
      if (onLoginSuccess) {
        onLoginSuccess({
          id: user.id,
          name: user.name,
          email: user.email,
          isSpecial: true
        });
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Error al iniciar sesión');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card login-modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="admin-login-close"
          onClick={() => { window.history.pushState({}, '', '/'); window.dispatchEvent(new PopStateEvent('popstate')); }}
          aria-label="Volver al inicio"
        >
          <i className="fas fa-times" />
        </button>
        <div className="login-modal-header">
          <div className="login-logo">
            <i className="fas fa-shield-alt" />
          </div>
          <h2>Administración Javiland</h2>
          <p>Acceso solo para equipo autorizado.</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error">
              <i className="fas fa-exclamation-triangle" />
              <span>{error}</span>
            </div>
          )}
          <div className="form-group">
            <label htmlFor="adm-email">Email</label>
            <input
              id="adm-email"
              type="email"
              name="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="adm-pass">Contraseña</label>
            <input
              id="adm-pass"
              type="password"
              name="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="login-submit-btn" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <i className="fas fa-spinner fa-spin" />
                Verificando…
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt" />
                Iniciar sesión
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
